import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { AssessmentLibrary } from './pages/AssessmentLibrary';
import { AssessmentLayout } from './components/layout/AssessmentLayout';
import { SystemDefinition } from './pages/assessment/SystemDefinition';
import { RegulationSelection } from './pages/assessment/RegulationSelection';
import { RiskClassification } from './pages/assessment/RiskClassification';
import { EvidenceCollection } from './pages/assessment/EvidenceCollection';
import { GapAnalysis } from './pages/assessment/GapAnalysis';
import { AuditTrail } from './pages/assessment/AuditTrail';
import { RemediationActions } from './pages/assessment/RemediationActions';
import { GovernFunction } from './pages/assessment/nist/GovernFunction';
import { MapFunction } from './pages/assessment/nist/MapFunction';
import { MeasureFunction } from './pages/assessment/nist/MeasureFunction';
import { ManageFunction } from './pages/assessment/nist/ManageFunction';
import { NistGapAnalysis } from './pages/assessment/nist/NistGapAnalysis';
function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/library" element={<AssessmentLibrary data-id="element-5" />} data-id="element-4" />

        <Route path="/assessment" element={<AssessmentLayout data-id="element-7" />} data-id="element-6">
          <Route index element={<Navigate to="/assessment/system" replace data-id="element-9" />} data-id="element-8" />
          <Route path="system" element={<SystemDefinition data-id="element-11" />} data-id="element-10" />
          <Route path="regulation" element={<RegulationSelection data-id="element-13" />} data-id="element-12" />
          <Route path="risk" element={<RiskClassification data-id="element-15" />} data-id="element-14" />
          <Route path="evidence" element={<EvidenceCollection data-id="element-17" />} data-id="element-16" />
          <Route path="analysis" element={<GapAnalysis data-id="element-19" />} data-id="element-18" />
          <Route path="audit-trail" element={<AuditTrail data-id="element-21" />} data-id="element-20" />
          <Route path="remediation" element={<RemediationActions data-id="element-23" />} data-id="element-22" />

          {/* NIST AI RMF Routes */}
          <Route path="nist/govern" element={<GovernFunction data-id="element-25" />} data-id="element-24" />
          <Route path="nist/map" element={<MapFunction data-id="element-27" />} data-id="element-26" />
          <Route path="nist/measure" element={<MeasureFunction data-id="element-29" />} data-id="element-28" />
          <Route path="nist/manage" element={<ManageFunction data-id="element-31" />} data-id="element-30" />
          <Route path="nist/analysis" element={<NistGapAnalysis data-id="element-33" />} data-id="element-32" />
        </Route>
      </Routes>
    </Router>;
}
export { App };